// src/api.js
import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL, // ✅ Route proxy Vercel
    withCredentials: true,
    headers: {
        "x-api-key": process.env.REACT_APP_API_KEY, // facultatif si pas utilisé
    },
});

export default API;
